import { EnumReduces } from "@/lib/redux/type";

export enum EnumEndpoints {
  LOGIN = '/customer/login/',
  REGIST = '/customer/register/',
  PROFILE = 'customer/profile/',
  UPDATE = 'customer/profile/',
  LOGOUT = '/logout/',
  RESET_PASSWORD = '/customer/forgot-password',
  VALIDATE_RESET_TOKEN = '/customer/validate-reset-token',
  SET_NEW_PASSWORD = '/customer/reset-password',
  MY_VOUCHERS = '/vouchers/',
  VOUCHERS = '/vouchers/get-vouchers',
  CUSTOMER_TEMP= '/customer/customer-temp/',

  FORCE_SEND_MAIL = '/mail/send',

  GET_AIRPORTS = '/flights/airports',
  SEARCH_FLIGHTS = '/flights/search/',
  SEARCH_MIN_FLIGHTS = '/flights/search-min/',
  SEARCH_MIN_FLIGHTS_V1 = '/flights/search-min/',
  GET_FARE_RULES_0 = '/flights/fare-rule',
  GET_FARE_RULES_1 = '/flights/fare-rule',
  GET_BAGGAGE = '/flights/get-baggage',
  GET_SEAT_MAP = '/flights/get-seat-map',
  FLIGHT_CREATE_ORDER = '/orders/create',
  FLIGHT_UPDATE_ORDER = '/orders/update',
  GET_GOOD_FLIGHTS = '/flights/good-flights',
  METASEARCH_BOOKING = '/v1/flights/metasearch/booking',
  METASEARCH_DAYVIEW_LANDING = '/v1/flights/metasearch/dayview-landing',
  GET_EXCHANGE_CURRENCY = '/flights/exchange/currency',
  GET_FARE_RULES_FEE_CONDITIONS = '/flights/fee-conditions-fare-rule',
  CAMPAIGN_LIST = '/campaign',
  CAMPAIGN_DETAIL = '/campaign',
  COMMON_ROUTES = '/seo-routes',
  COMMON_ROUTE_DETAIL = '/seo-routes',
  FLASH_SALE_LIST = '/flash-sales/public/campaign/list',
  PRODUCTS_GET = '/products/get',

  BOOKING_CHECKOUT = '/booking/checkout',
  BOOKING_REPAYMENT = '/booking/re-payment',

  ORDER_DETAIL = '/orders/get/',
  ORDER_DETAIL_PARTNER = '/api/partner/booking/booking-detail/',
  GET_ALL_ORDERS = '/orders/get/',
  PREVIEW_ORDER = '/booking/order/preview',

  HOTEL_SEARCH = '/searchHotels',
  HOTEL_SEARCH_KEYWORD = '/search/keyword',
  HOTEL_DETAIL = '/search/detail',
  HOTEL_DETAIL_RESOURCE = '/resources',
  HOTEL_FILTER_OPTION = '/search/filter-options',
  HOTEL_SORT_OPTION = '/search/sort-options',

  HOTEL_LOCATIONS_SEARCH = '/location/search',
  HOTEL_LOCATIONS_DETAIL = '/location',
  HOTEL_LOCATIONS_INIT = '/location/init',
  HOTEL_LOCATIONS_POPULAR = '/location/popular',
  HOTEL_HEALTHZ = '/healthz',

  HOTEL_ORDER = '/order',
  HOTEL_ORDER_PRECHECK = '/order/precheck',
  HOTEL_BOOKING_CANCEL = '/booking/cancel',
  HOTEL_BOOKING_CONFIRM_CANCEL = '/booking/confirm-cancel',

  HOTEL_CITIES = '/api/metadata/cities',
  HOTEL_COUNTRIES = '/api/metadata/countries',
  HOTEL_AREAS = '/api/metadata/areas',
  HOTEL_DETAIL_STATISTICS = '/statistics',
  HOTEL_DETAIL_REVIEWS = '/reviews',

  HOTEL_MASTER_DETAIL = '/public/hotels',

  HOTEL_GOOD_PRICES = '/good-price/public',

  // TOURS
  TOURS_COLLECTIONS = '/tours/collections',
  TOURS_COLLECTIONS_BY_SLUG = '/tours/collections',
  TOUR_DETAILS = '/tours/tour',
  TOURS_CATEGORIES = '/tours/category',
  TOURS_SEARCH = '/tours/search',

  // voucher
  VOUCHER_GET_ALL = '/vouchers/get-all',
  VOUCHER_CUSTOMER_GET_ALL = '/vouchers',
  VOUCHER_VALIDATE = '/vouchers/codes/validate',

  // BLOG
  BLOG_LIST = '/blog',
  BLOG_DETAIL = '/blog/slug',
  BLOG_CATEGORY = '/blog/category',

  // SEO ROUTES

  SEO_ROUTES = '/seo-routes',

  // ESIM
  ESIM_COUNTRIES = '/esim/countries',
  // ESIM_PACKAGES = '/esim/packages', // legacy live-proxy, replaced by catalog/public/list
  ESIM_CATALOG_PUBLIC_LIST = '/esim/catalog/public/list',
  ESIM_CATALOG_PUBLIC_DETAIL = '/esim/catalog/public/detail',
  ESIM_CATALOG_PUBLIC_FILTERS = '/esim/catalog/public/filters',
  ESIM_COLLECTION_PUBLIC_LIST = '/esim/collection/public/list',
  PRODUCT_CONTENT_PUBLIC_LIST = '/product-content/public/list',

  // FAQ
  FAQ_SHOW = '/faqs/show',

  // VISA
  VISA_PROGRAMS_LIST = '/visa/programs/list',
  VISA_INQUIRY_SUBMIT = '/visa/inquiries/submit',
}

export enum EnumEndpointsName {
  LOGIN = 'login',
  REGIST = 'regist',
  LOGOUT = 'logout',
  PROFILE = 'profile',
  UPDATE = 'update',
  RESET_PASSWORD = 'reset_password',
  VALIDATE_RESET_TOKEN = 'validate_reset_token',
  SET_NEW_PASSWORD = 'set_new_password',
  MY_VOUCHERS = 'my_vouchers',
  VOUCHERS = 'vouchers',
  CUSTOMER_TEMP = 'customer_temp',

  FORCE_SEND_MAIL = 'force_send_mail',

  // flight result
  GET_AIRPORTS = 'get_airports',
  SEARCH_FLIGHTS = 'search_flights',
  SEARCH_MIN_FLIGHTS = 'search_min_flights',
  SEARCH_MIN_FLIGHTS_V1 = 'search_min_flights_v1',
  GET_FARE_RULES_0 = 'get_fare_rules_0',
  GET_FARE_RULES_1 = 'get_fare_rules_1',
  GET_BAGGAGE = 'get_baggage',
  GET_SEAT_MAP = 'get_seat_map',
  GET_GOOD_FLIGHTS = 'get_good_flights',
  GET_EXCHANGE_CURRENCY = 'get_exchange_currency',
  GET_FARE_RULES_FEE_CONDITIONS = 'get_fare_rule_fee_conditions',
  CAMPAIGN_LIST = 'campaign_list',
  CAMPAIGN_DETAIL = 'campaign_detail',
  COMMON_ROUTES = 'common_routes',
  COMMON_ROUTE_DETAIL = 'common_route_detail',
  FLASH_SALE_LIST = 'flash_sale_list',

  // booking flight
  FLIGHT_CREATE_ORDER = 'flight_create_order',
  FLIGHT_UPDATE_ORDER = 'flight_update_order',

  BOOKING_CHECKOUT = 'booking_checkout',
  BOOKING_REPAYMENT = 'booking_repayment',

  // order
  ORDER_DETAIL = 'order_detail',
  ORDER_DETAIL_PARTNER = 'order_detail_partner',
  GET_ALL_ORDERS = 'get_all_orders',
  PREVIEW_ORDER = 'preview_order',

  // hotel
  HOTEL_SEARCH = 'hotels_search',
  HOTEL_SEARCH_KEYWORD = 'hotels_search_keyword',
  HOTEL_DETAIL = 'hotels_detail',
  HOTEL_DETAIL_RESOURCE = 'hotels_detail_resource',
  HOTEL_FILTER_OPTION = 'hotels_filter_option',
  HOTEL_SORT_OPTION = 'hotels_sort_option',

  HOTEL_LOCATIONS_SEARCH = 'hotels_locations_search',
  HOTEL_LOCATIONS_DETAIL = 'hotels_locations_detail',
  HOTEL_LOCATIONS_INIT = 'hotels_locations_init',
  HOTEL_LOCATIONS_POPULAR = 'hotels_locations_popular',
  HOTEL_HEALTHZ = 'hotels_healthz',

  HOTEL_ORDER = 'hotels_order',
  HOTEL_ORDER_PRECHECK = 'hotels_order_precheck',
  HOTEL_BOOKING_CANCEL = 'hotels_booking_cancel',
  HOTEL_BOOKING_CONFIRM_CANCEL = 'hotels_booking_confirm_cancel',
  HOTEL_DETAIL_STATISTICS = 'hotels_detail_statistics',
  HOTEL_DETAIL_REVIEWS = 'hotel_detail_reviews',

  HOTEL_CITIES = 'hotels_cities',
  HOTEL_COUNTRIES = 'hotels_countries',
  HOTEL_AREAS = 'hotels_areas',

  HOTEL_MASTER_DETAIL = 'hotel_master_detail',

  HOTEL_GOOD_PRICES = 'hotel_good_prices',

  // TOURS
  TOURS_COLLECTIONS = 'tours_collections',
  TOURS_COLLECTIONS_BY_SLUG = 'tours_collections_by_slug',
  TOUR_DETAILS = 'tour_details',
  TOURS_CATEGORIES = 'tours_categories',
  TOURS_SEARCH = 'tours_search',

  // VOUCHER
  VOUCHER_GET_ALL = 'voucher_get_all',
  VOUCHER_CUSTOMER_GET_ALL = 'voucher_customer_get_all',
  VOUCHER_VALIDATE = 'voucher_validate',

  // BLOG
  BLOG_LIST = 'blog_list',
  BLOG_DETAIL = 'blog_detail',
  BLOG_CATEGORY = 'blog_category',

  // SEO ROUTES
  SEO_ROUTES = 'seo_routes',

  // ESIM
  ESIM_COUNTRIES = 'esim_countries',
  // ESIM_PACKAGES = 'esim_packages', // legacy live-proxy, replaced by catalog/public/list
  ESIM_CATALOG_PUBLIC_LIST = 'esim_catalog_public_list',
  ESIM_CATALOG_PUBLIC_DETAIL = 'esim_catalog_public_detail',
  ESIM_CATALOG_PUBLIC_FILTERS = 'esim_catalog_public_filters',
  ESIM_COLLECTION_PUBLIC_LIST = 'esim_collection_public_list',
  PRODUCT_CONTENT_PUBLIC_LIST = 'product_content_public_list',

  // FAQ
  FAQ_SHOW = 'faq_show',

  // VISA
  VISA_PROGRAMS_LIST = 'visa_programs_list',
  VISA_INQUIRY_SUBMIT = 'visa_inquiry_submit',
}

export enum EnumMethod {
  POST = 'post',
  GET = 'get',
  PUT = 'put',
  DEL = 'del'
}

export type EndpointSetting = {
  method: EnumMethod,
  endpoint: EnumEndpoints,
  params?: { [paramName: string]: any },
  body?: { [prop: string]: any },
  caller?: (state: any, action: any, endpointName: any) => any,
  callerService?: (payload: any) => any,
  /** Copy these fields from response root into unwrapped `data` payload (opt-in per endpoint). */
  attachRootFields?: string[],
  api: any
}

export type TypeEndpoint = {
  [prop in EnumReduces]: {
    [endpointName in EnumEndpointsName]?: EndpointSetting
  }
}